import { toMinutes } from '../utils/date';

export const prepareDriver = ({
  vehicleTypeCode,
  dutyStartTime,
  dutyEndTime,
  plannedDepartTime,
  plannedReturnTime,
  deliveryStopTime,
  collectionStopTime,
  driverCode,
}) => {
  if (!driverCode) {
    return null;
  }

  return {
    vehicleTypeCode,
    dutyStartTime,
    dutyEndTime,
    plannedDepartTime,
    plannedReturnTime,
    deliveryStopTime: toMinutes(deliveryStopTime),
    collectionStopTime: toMinutes(collectionStopTime),
    driverCode,
  };
};
